export const version = "bignumber/5.6.1";
//# sourceMappingURL=_version.js.map